export { default as Facebook } from './Facebook'
export { default as Twitter } from './Twitter'
export { default as Instagram } from './Instagram'
export { default as Desktop } from './Desktop'
export { default as Weibo } from './Weibo'
export { default as Linkedin } from './Linkedin'


// WEBPACK FOOTER //
// ./src/components/Shapes/Social/index.js